import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <div style={{ padding: "200px 20px 100px", textAlign: "center", minHeight: "60vh" }}>
      <Helmet>
        <title>404 – Page Not Found | A to Z Landscaping</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 style={{ fontSize: "clamp(48px, 8vw, 90px)", margin: 0 }}>404</h1>
      <p style={{ fontSize: 20, margin: "10px 0 30px" }}>Sorry, this page doesn't exist.</p>
      <Link
        to="/"
        style={{ display: "inline-block", background: "#00b96b", color: "#fff", padding: "14px 28px", borderRadius: 40, textDecoration: "none", fontWeight: 700 }}
      >
        Back to Home
      </Link>
    </div>
  );
}